// Fire-and-forget audit log POSTs to robot-hub's /events endpoint.
//
// This is best-effort telemetry: we never await the request, and any failure
// is swallowed so it can't affect the UI. Routing for fleet/auth endpoints:
//   - Kiosk (on-robot): http://localhost:8765 — local auth proxy that
//     injects credentials and forwards to the cloud hub. May be offline.
//   - Anywhere else: HUB_URL — caller must pass a Cognito bearer token.

import { HUB_URL, isKiosk } from './constants';

export type AuditExtraInfo =
  | { type: 'started_task'; tray_count?: number; object_count?: number }
  | { type: 'task_completed'; cycle_time_seconds: number; task_id?: string | null }
  | {
      type: 'dispatched_robot';
      destination: string;
      travel_time_seconds?: number | null;
      distance_meters?: number | null;
    }
  | { type: 'started_driving' }
  | { type: 'e_stop_pressed'; e_stop_type: 'electronic' | 'physical' };

export function hubBaseUrl(): string {
  if (isKiosk) return 'http://localhost:8765';
  return HUB_URL;
}

export interface AuditEventArgs {
  robotId: number;
  userId?: number | null;
  extraInfo: AuditExtraInfo;
  token?: string | null;
}

export function logAuditEvent({ robotId, userId, extraInfo, token }: AuditEventArgs): void {
  try {
    const body = JSON.stringify({
      robot_id: robotId,
      user_id: userId ?? null,
      extra_info: extraInfo,
    });
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    void fetch(`${hubBaseUrl()}/events`, {
      method: 'POST',
      headers,
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never propagate
  }
}
